"use client";
import { observer, useStore } from "../../../../service/mobx";
import SearchFilterChip from ".";
import MenuTask from "../../../../component/Menu/menus/Search/Task";
import { entityMap } from "../../../../component/Search/Hooks";

export default observer(function FilterTask() {
  const { search } = useStore();
  const disabled =
    search.filterType === undefined ||
    search.filterType === "tasks" ||
    search.filterStars !== undefined;
  const numberOfTasks = search.filterTask.size;

  return (
    <SearchFilterChip
      param="task"
      disabled={disabled}
      StartIcon={entityMap.task.Icon}
      label={
        numberOfTasks
          ? `${numberOfTasks < 10 ? numberOfTasks : "9+"} task${
              numberOfTasks === 1 ? "" : "s"
            }`
          : undefined
      }
      Menu={{
        Component: MenuTask,
        sx: {
          paper: { maxHeight: "70vh !important" },
          menuList: { pt: 0, maxHeight: "100%" }
        }
      }}
    />
  );
});
